import { render } from "./GenreListView.vue?vue&type=template&id=2cb9ee5e"
import script from "./GenreListView.vue?vue&type=script&lang=js"
export * from "./GenreListView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__